import CitySEOHead from "@/components/feature/CitySEOHead";
import TampaHeroSection from "./components/HeroSection";
import TampaStickyNav from "./components/StickyNav";
import TampaProcessingTimeSection from "./components/ProcessingTimeSection";
import TampaServicesSection from "./components/ServicesSection";
import TampaLocalAreaSection from "./components/LocalAreaSection";
import TampaTestimonialsSection from "./components/TestimonialsSection";
import TampaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import TampaComparisonSection from "./components/ComparisonSection";
import TampaMistakesSection from "./components/MistakesSection";
import TampaHowItWorksSection from "./components/HowItWorksSection";
import TampaFAQSection, { faqs } from "./components/FAQSection";
import TampaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import TampaFinalCTA from "./components/FinalCTA";
import TampaTravelTimingSection from "./components/TravelTimingSection";
import TampaDestinationsSection from "./components/DestinationsSection";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Tampa, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Tampa, FL — as fast as 2–3 business days. A+ BBB rated, registered State Dept. courier serving Tampa, St. Petersburg, Clearwater, and Tampa Bay area travelers needing urgent, fast, or same-day passport help.";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function TampaPage() {
  return (
    <>
      <CitySEOHead
        city="Tampa"
        state="Florida"
        stateAbbr="FL"
        route="/cities/tampa"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Tampa, Florida"
        geoPosition="27.9506;-82.4572"
        keywords="expedited passport Tampa, emergency passport Tampa FL, same day passport Tampa, fast passport Florida, passport renewal Tampa, Tampa passport courier"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-09"
      />

      <div className="font-sans">
        <TampaHeroSection />
        <TampaStickyNav />
        <TampaProcessingTimeSection />
        <TampaLocalAreaSection />
        <TampaServicesSection />
        <TampaTravelTimingSection />
        <TampaDestinationsSection />
        <TampaTestimonialsSection />
        <TampaAcceptanceFacilitiesSection />
        <TampaComparisonSection />
        <TampaMistakesSection />
        <TampaHowItWorksSection />
        <TampaFAQSection />
        <TampaHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/tampa" state="FL" />
        <TampaFinalCTA />
      </div>
    </>
  );
}